import React from 'react';
import './PlanTopicBar.css';

// One line for a Paths plan link's ?topic=. It is fixed to the viewport
// because every exam workspace is a full-screen fixed layer; a line in the
// page flow would sit behind it. It never starts anything by itself: Start
// is the student's click.
const PlanTopicBar = ({ resolution, onStart, onDismiss }) => {
  if (!resolution || !['found', 'not_found', 'invalid'].includes(resolution.status)) return null;
  const found = resolution.status === 'found';
  let message;
  if (found) {
    message = `From your plan: ${resolution.label}`;
  } else if (resolution.status === 'not_found') {
    message = `We couldn't find the topic "${resolution.echo}" from your plan.`;
  } else {
    message = "Your plan's link didn't name a usable topic.";
  }
  return (
    <div className={`plan-topic-bar${found ? '' : ' plan-topic-bar--missing'}`} role="status">
      <span className="plan-topic-bar__text">{message}</span>
      {found && (
        <button type="button" className="plan-topic-bar__start" onClick={onStart}>
          Start
        </button>
      )}
      <button type="button" className="plan-topic-bar__dismiss" onClick={onDismiss} aria-label="Dismiss">
        ×
      </button>
    </div>
  );
};

export default PlanTopicBar;
